import DeleteProjectModal from './DeleteProjectModal'

export default DeleteProjectModal
